import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Splash from "./pages/Splash";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AuthCallback from "./pages/AuthCallback";
import Pricing from "./pages/Pricing";
import Dashboard from "./pages/Dashboard";
import ProjectWorkspace from "./pages/ProjectWorkspace";
import RolesPage from "./pages/RolesPage";
import TeammatesPage from "./pages/TeammatesPage";
import TemplatesPage from "./pages/TemplatesPage";
import ProgramsPage from "./pages/ProgramsPage";
import PortfoliosPage from "./pages/PortfoliosPage";
import ResourceLoadPage from "./pages/ResourceLoadPage";
import InvitesPage from "./pages/InvitesPage";
import AcceptInvite from "./pages/AcceptInvite";
import PublicProject from "./pages/PublicProject";
import SettingsPage from "./pages/SettingsPage";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import About from "./pages/About";
import ExecutivePage from "./pages/ExecutivePage";
import RiskTemplatesPage from "./pages/RiskTemplatesPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";

function Router() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Splash />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/app" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/app/projects/:id" element={<ProtectedRoute><ProjectWorkspace /></ProtectedRoute>} />
      <Route path="/app/roles" element={<ProtectedRoute><RolesPage /></ProtectedRoute>} />
      <Route path="/app/teammates" element={<ProtectedRoute><TeammatesPage /></ProtectedRoute>} />
      <Route path="/app/templates" element={<ProtectedRoute><TemplatesPage /></ProtectedRoute>} />
      <Route path="/app/programs" element={<ProtectedRoute><ProgramsPage /></ProtectedRoute>} />
      <Route path="/app/portfolios" element={<ProtectedRoute><PortfoliosPage /></ProtectedRoute>} />
      <Route path="/app/resources" element={<ProtectedRoute><ResourceLoadPage /></ProtectedRoute>} />
      <Route path="/app/invites" element={<ProtectedRoute><InvitesPage /></ProtectedRoute>} />
      <Route path="/app/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/app/risk-templates" element={<ProtectedRoute><RiskTemplatesPage /></ProtectedRoute>} />
      <Route path="/accept-invite/:token" element={<AcceptInvite />} />
      <Route path="/share/:token" element={<PublicProject />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/about" element={<About />} />
      <Route path="/app/executive" element={<ProtectedRoute><ExecutivePage /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Router />
        <Toaster theme="dark" position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
